export enum ExternalAttendeeQueryKeys {
  GetExternalAttendeesSearch = 'ExternalAttendeeGetExternalAttendeesSearch',
}
